/* ================================================================
 * Copyright © 2025 Tobeunicorn Co., Ltd. All rights reserved.
 *
 * 프로젝트명 : ArmyLink V1.0
 * 설명 : 사용하는 아이콘 기본 스타일을 지정해놓은 컴포넌트
 * 버전 : 1.0
 * 파일명 : CommonIcons.tsx
 * 작성자 : 강동형
 * 작성일 : 2025-03-01
 * ================================================================ 
 * 수정 : 2025-07-02, 강동형 : 저작권 추가, 캘린더와 돋보기가 함께있는 아이콘 & 원형 내부에 i가 있는 아이콘 추가
 * 수정 : 2025-07-03, 강동형 : 지도와 돋보기가 함께있는 아이콘 추가
 * 수정 : 2025-07-10, 강동형 : 업로드 아이콘 추가, 로봇 아이콘 추가
 * 수정 : 2025-07-16, 강동형 : 아래쪽 꺽쇠 화살표 추가, 사람 아이콘(흰색) 추가
 * 수정 : 2025-07-17, 강동형 : 하트 모양, 회색 다운로드, 회색 캘린더 아이콘 추가
 *================================================================*/

import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowDownIosNewIcon from '@mui/icons-material/KeyboardArrowDown';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { SvgIconProps } from '@mui/material';
import LinkSvg from 'src/assets/images/Icon_Link.svg'
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import FlagIcon from 'src/assets/images/Icon_Flag.svg'
import StarShieldIcon from 'src/assets/images/Icon_StarShield.svg'
import Icon_AI_Text from 'src/assets/images/Icon_AI_Text.svg'
import Icon_SearchTeal from 'src/assets/images/Icon_Search_Teal.svg'
import Icon_FoldedPaperTeal from 'src/assets/images/Icon_FoldedPaper_Teal.svg'
import Icon_HeartTeal from 'src/assets/images/Icon_Heart_Teal.svg'
import Icon_PersonTeal from 'src/assets/images/Icon_Person_Teal.svg'
import IconPerson from 'src/assets/images/Icon_Person.svg'
import IconLoading from 'src/assets/images/Icon_Loading.svg'
import PlayArrowRoundedIcon from '@mui/icons-material/PlayArrowRounded';
import CloseIcon from '@mui/icons-material/Close';
import EmptyCalendar from 'src/assets/images/Icon_EmptyCalendar.svg'
import InformWithCircle from 'src/assets/images/Icon_Inform.svg'
import InformWithCircle_Teal from 'src/assets/images/Icon_Inform_Teal.svg'
import InformWithCircle_White from 'src/assets/images/Icon_Inform_White.svg'
import EmptyMap from 'src/assets/images/Icon_EmptyMap.svg'
import Crosshair from 'src/assets/images/Icon_Crosshair.svg'
import Upload from 'src/assets/images/Icon_Upload.svg'
import Robot from 'src/assets/images/Icon_Robot.svg'
import Icon_downloadGray from 'src/assets/images/Icon_download_Gray.svg'
import IconCalendar from 'src/assets/images/Icon_Calendar_Grey.svg'
import IconShield from 'src/assets/images/Icon_Shield.svg'
import IconMedalion from 'src/assets/images/Icon_Medalion.svg'
import IconPeople from 'src/assets/images/Icon_People.svg'
import FavoriteIcon from '@mui/icons-material/Favorite';


// 하트 모양
// 좌측 화살표 ( 꺽쇠 )
// 아래측 화살표 ( 꺽쇠 )
// 원형 내부에 X표가 쳐진 아이콘
// 쇠사슬
// 우측 화살표 ( 일반 )
// 원형 내부에 + 모양
// 접힌 종이
// 깃발
// 별이 있는 방패
// 움직이는 AI 아이콘
// 돋보기 
// 접힌 종이2
// 사람
// 사람Teal
// 로딩 아이콘
// 우측 화살표 ( 플레이 )
// X 표
// 캘린더와 돋보기가 함께 있는 아이콘
// 원형 내부에 i가 있는 아이콘
// 지도와 돋보기가 함께 있는 아이콘
// 크로스헤어 아이콘
// 업로드 아이콘
// 회색 다운로드 아이콘
// 회색 캘린더 아이콘

type IconProps = React.ImgHTMLAttributes<HTMLImageElement>;

// type IconProps_Text = React.HTMLAttributes<HTMLDivElement> & {
//   text?: string;
// };

const HeartIconSx = {

}

// 하트 모양
export const Icon_Heart = (props: SvgIconProps) => <FavoriteIcon {...props} sx={{...HeartIconSx,...props.sx}}/>;

const ArrowBackIosNewIconSx={
  transform:'scale(0.7)', color:'black'
}

// 왼측 화살표 ( 꺽쇠 )
export const Icon_ArrowBack = (props: SvgIconProps) => <ArrowBackIosNewIcon {...props} sx={{...ArrowBackIosNewIconSx,...props.sx}}/>;

// 아래측 화살표 ( 꺽쇠 )
export const Icon_ArrowDown = (props: SvgIconProps) => <ArrowDownIosNewIcon {...props} sx={{...props.sx}}/>;

const ErrorOutlineIconSx = {
  transform : 'scale(1.2)'
}

export const Icon_CircleError = (props: SvgIconProps)=> <ErrorOutlineIcon  {...props} sx={{...ErrorOutlineIconSx,...props.sx}}/>

export const Icon_Link = (props:IconProps) => (
  <img
    src={LinkSvg} // public 경로에 위치한 SVG 파일
    alt="링크 아이콘"
    {...props}
  />
);

const KeyboardArrowRightSx={
  transform:'scale(1)', color:'black'
}

export const Icon_ArrowRight = (props: SvgIconProps) => <KeyboardArrowRight {...props} sx={{...KeyboardArrowRightSx,...props.sx}}/>;

const AddCircleIconSx = {

}

export const Icon_AddCircle = (props: SvgIconProps)=> <AddCircleIcon {...props} sx={{...AddCircleIconSx,...props.sx}}></AddCircleIcon>

const InsertDriveFileIconSx = {

};

// 접힌 종이
export const Icon_EdgeFoldPaper = (props: SvgIconProps) => (
  <InsertDriveFileIcon {...props} sx={{ ...InsertDriveFileIconSx, ...props.sx }} />
);

export const Icon_Flag = (props: IconProps) => (
  <img
    src={FlagIcon}
    alt="깃발 아이콘"
    {...props}
  />
);

export const Icon_StarShield = (props: IconProps) => (
  <img
    src={StarShieldIcon}
    alt="방패 아이콘"
    {...props}
  />
);

const baseStyle: React.CSSProperties = {
  position: 'relative',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '60px',
  height: '60px',
  borderRadius: '100%',
  border: '0.5px solid #40C2E8',
  overflow: 'hidden',
};

const layer1: React.CSSProperties = {
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  borderRadius: '100%',
  background: 'radial-gradient(49.47% 49.47% at 50% 50%, rgba(255,255,255,0.0) 75%, #0AB2E4 100%)',
  animation: 'fadeOut 4s infinite ease-in-out',
  zIndex: 0,
};

const layer2: React.CSSProperties = {
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  borderRadius: '100%',
  background: 'radial-gradient(49.47% 49.47% at 50% 50%, rgba(255,255,255,0.0) 25%, #0AB2E4 100%)',
  animation: 'fadeIn 4s infinite ease-in-out',
  zIndex: 0,
};

export const Icon_AiMotion = ({ style, ...rest }: IconProps) => {
  return (
    <>
      <style>
        {`
          @keyframes fadeIn {
            0% { opacity: 0; }
            50% { opacity: 1; }
            100% { opacity: 0; }
          }

          @keyframes fadeOut {
            0% { opacity: 1; }
            50% { opacity: 0; }
            100% { opacity: 1; }
          }
        `}
      </style>

      <div style={{ ...baseStyle, ...style }} {...rest}>
        <div style={layer1}></div>
        <div style={layer2}></div>
        <img src={Icon_AI_Text} alt='AI 아이콘' style={{ zIndex: 1 }} />
      </div>
    </>
  );
};

export const Icon_Search_Teal = (props: IconProps) => (
  <img
    src={Icon_SearchTeal}
    alt="청록색 돋보기 아이콘"
    {...props}
  />
);

export const Icon_FoldedPaper_Teal = (props: IconProps) => (
  <img
    src={Icon_FoldedPaperTeal}
    alt="청록색 접힌종이 아이콘"
    {...props}
  />
);

export const Icon_Heart_Teal = (props: IconProps) => (
  <img
    src={Icon_HeartTeal}
    alt="청록색 하트 아이콘"
    {...props}
  />
);

export const Icon_Person_Teal = (props: IconProps) => (
  <img
    src={Icon_PersonTeal}
    alt="청록색 사람 아이콘"
    {...props}
  />
);

export const Icon_Person = (props: IconProps) => (
  <img
    src={IconPerson}
    alt="청록색 사람 아이콘"
    {...props}
  />
);

export const Icon_Loading = (props: IconProps) => (
  <img
    src={IconLoading}
    alt="로딩 아이콘"
    {...props}
  />
);

const PlayIconSx = {
  transform : 'scale(1.5)',
  color : '#C6C6C6'
}

//오른쪽 화살표(플레이 버튼 모양)
export const Icon_Play = (props: SvgIconProps) => 
<PlayArrowRoundedIcon {...props} sx={{...PlayIconSx,...props.sx}}/>;

const Icon_X_MarkSx = {
  // transform : 'scale(1.5)',
  // color : '#C6C6C6'
}

//X 표
export const Icon_X_Mark = (props: SvgIconProps) => 
<CloseIcon {...props} sx={{...Icon_X_MarkSx,...props.sx}}/>;

export const Icon_EmptyCalendar = (props: IconProps) => (
  <img
    src={EmptyCalendar}
    alt="캘린더와 돋보기가 함께 있는 아이콘"
    {...props}
  />
);

export const Icon_Inform = (props: IconProps) => (
  <img
    src={InformWithCircle}
    alt="원형 내부에 i가 있는 아이콘"
    {...props}
  />
);

export const Icon_Inform_Teal = (props: IconProps) => (
  <img
    src={InformWithCircle_Teal}
    alt="원형 내부에 i가 있는 아이콘"
    {...props}
  />
);

export const Icon_Inform_White = (props: IconProps) => (
  <img
    src={InformWithCircle_White}
    alt="원형 내부에 i가 있는 아이콘"
    {...props}
  />
);

export const Icon_EmptyMap = (props: IconProps) => (
  <img
    src={EmptyMap}
    alt="지도와 돋보기가 함께 있는 아이콘"
    {...props}
  />
);

export const Icon_CrossHair = (props: IconProps) => (
  <img
    src={Crosshair}
    alt="크로스헤어 아이콘"
    {...props}
  />
);

export const Icon_Upload = (props: IconProps) => (
  <img
    src={Upload}
    alt="업로드 아이콘"
    {...props}
  />
);

export const Icon_Robot = (props: IconProps) => (
  <img
    src={Robot}
    alt="로봇 아이콘"
    {...props}
  />
);

export const Icon_download_Gray = (props: IconProps) => (
  <img
    src={Icon_downloadGray}
    alt="회색 다운로드 아이콘"
    {...props}
  />
);

export const Icon_Calendar = (props: IconProps) => (
  <img
    src={IconCalendar}
    alt="회색 캘린더 아이콘"
    {...props}
  />
);

export const Icon_Shield = (props: IconProps) => (
  <img
    src={IconShield}
    alt="흰색 방패 아이콘"
    {...props}
  />
);

export const Icon_Medalion = (props: IconProps) => (
  <img
    src={IconMedalion}
    alt="흰색 메달 아이콘"
    {...props}
  />
);

export const Icon_People = (props: IconProps) => (
  <img
    src={IconPeople}
    alt="흰색 그룹 아이콘"
    {...props}
  />
);